import React, { useEffect } from 'react';
import { PageForm } from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import DashboardForm from '/src/features/plugins/dashboard/components/DashboardForm/DashboardForm';
import QuotePart from '/src/components/quote/QuotePart';
import { useNavigate } from "react-router-dom";
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
function DashboardFormPage() {
    const location = useLocation();
    const navigate = useNavigate();
    var data = null;
    var type = null;

    if (location.state != null) {
        data = location.state.data;
        type = location.state.type
    }
    useEffect(() => {
        if (location.pathname.includes("/update") && location.state == null) {
            return navigate(urlWithRoutingCompany('/dashboards/list'))
        }
    });
    return (
        <PageForm>
            <DashboardForm data={data} type={type} />
            <QuotePart />
        </PageForm>

    );
}
export default DashboardFormPage;